import PresenceChange from './PresenceChange';
import ProductHistoryCompanyChange from './ProductHistoryCompanyChange';
import ProductHistoryPriceChange from './ProductHistoryPriceChange';
import ProductHistoryProduct from './ProductHistoryProduct';

export enum Type {
	companyChange = 'company-change',
	priceChange = 'price-change',
	presenceChange = 'presence-change',
}

export default class ProductHistoryEvent {
	eventType: Type;

	product: ProductHistoryProduct;

	companyChange: ProductHistoryCompanyChange | null;

	priceChange: ProductHistoryPriceChange | null;

	presenceChange: PresenceChange | null;

	effectiveSince: Date;

	constructor(
		eventType: Type,
		product: ProductHistoryProduct,
		companyChange: ProductHistoryCompanyChange | null,
		priceChange: ProductHistoryPriceChange | null,
		presenceChange: PresenceChange | null,
		effectiveSince: Date
	) {
		this.eventType = eventType;
		this.product = product;
		this.companyChange = companyChange;
		this.priceChange = priceChange;
		this.presenceChange = presenceChange;
		this.effectiveSince = effectiveSince;
	}

	isCompanyChange(): boolean {
		return this.eventType === Type.companyChange;
	}

	isPriceChange(): boolean {
		return this.eventType === Type.priceChange;
	}

	isPresenceChange(): boolean {
		return this.eventType === Type.presenceChange;
	}
}
